import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { billingErrorToast } from '@components/BillingError/toast';
import {
  UpdatePaymentMethodToDefaultParams,
  updatePaymentMethodToDefault,
} from '@utils/backend-api/stripe';
import { BillingErrorPayload, normalizeBillingError } from '@utils/billingErrors';

export default function useSetPaymentMethodToDefault() {
  const { mutate, mutateAsync, isLoading } = useMutation(
    (values: UpdatePaymentMethodToDefaultParams) => updatePaymentMethodToDefault(values),
    {
      onSuccess: () => {
        toast.success('Payment method has been updated');
      },
      onError: (error: Partial<BillingErrorPayload> & { message?: string }) => {
        billingErrorToast(
          normalizeBillingError(error, 'Payment method was not saved. Please try again.')
        );
      },
    }
  );

  return {
    mutate,
    mutateAsync,
    isLoading,
  };
}
